<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col text-right">
          <button type="button" @click="newC" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#exampleModal">Add new</button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <vue-good-table
      :line-numbers="true"
      :columns="columns"
      :rows="rows"
      :pagination-options="{
          enabled: true,
          mode: 'pages',
          perPage: 10
          }"
      :search-options="{
        enabled: true,
        placeholder: 'Search this table',
        }"
      >
          <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
      <button class="btn btn-success btn-sm" @click="opensub(props.row.id,props.row.name)" >sub-categories</button>
      <button @click="editCat(props.row)"  type="button" class="btn btn-sm btn-primary btn-circle">
          <i class="fas fa-edit"></i>
      </button>  
      <button @click="deleteCat(props.row.id)" type="button" class="btn btn-danger btn-sm btn-circle">
          <i class="fas fa-trash"></i>
      </button>
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>

      </vue-good-table>
    </div>
    <newCategory :form="form" @reload="getCategories()"></newCategory>
    <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage">
            </loading>
  </div>
  </div>
</template>
<script>
  import newCategory from '../modals/NewCategory'
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  export default {
    name: 'CategoryTable',
    components:{
      newCategory,
      Loading
    },
    created(){
        this.getCategories();
    },
    props: {
      type:String,
      title: String,
      
    },
    data() {
      return {
          form:{
              id: 0,
              name: '',
              image: '',
              hasEdit: 0
          },
        fullPage:true,
        isLoading:false,
        categories:{
          id: 0,
          name: ''
        },
        


      columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Actions',
          field: 'action',

        },


      ],
      rows: [],
    };
  },




    methods:{
      getCategories(){
        this.axios.get('admin/shopLocal/category')
        .then((response)=>{
          this.rows = response.data
        })
      },
      newC(){
        this.form.id = 0
        this.form.name = ''
        this.form.image = ''
        this.form.hasEdit = 0
      },
      opensub(id, name){
        this.categories.id = id;
        this.categories.name = name;
        this.$emit("openSub", this.categories);
      },
      editCat(cat){
        this.form.id = cat.id;
        this.form.name = cat.name;
        this.form.image = cat.filePath
        $('#exampleModal').modal('show');
      },
      deleteCat(id) {
                this.$swal({ 
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                      this.isLoading = true;
                        this.axios.delete('/admin/shopLocal/category/' + id).then(() => {
                            this.isLoading = false;
                            this.$swal(
                                'Deleted!',
                                'Category has been deleted.',
                                'success'
                            )
                            this.getCategories();
                        })
                        .catch(() => {
                            this.isLoading = false;
                            this.$swal("Failed!", "There was something wrong.", "warning");
                })
                    }
                })
            }
    }
  }
</script>
<style>
</style>
